import { SUPPORT_EMAIL_ID } from "../../utils/helper";

export const upgradeModalMessages = (t, planName, emailTransactionLimit) =>
  planName === 'Premium'
    ? t(
        TEMPLATE_VARIABLES_SIDEBAR.PREMIUM_ACCOUNT_UPGRADE_MESSAGE.key,
        TEMPLATE_VARIABLES_SIDEBAR.PREMIUM_ACCOUNT_UPGRADE_MESSAGE.value,
        { emailId: SUPPORT_EMAIL_ID },
      )
    : planName === 'Free'
    ? t(
        TEMPLATE_VARIABLES_SIDEBAR.FREE_PLAN_UPGRADE_MESSAGE.key,
        TEMPLATE_VARIABLES_SIDEBAR.FREE_PLAN_UPGRADE_MESSAGE.value,
        { emailTransactionLimit },
      )
    : t(
        TEMPLATE_VARIABLES_SIDEBAR.STANDARD_PLAN_UPGRADE_MESSAGE.key,
        TEMPLATE_VARIABLES_SIDEBAR.STANDARD_PLAN_UPGRADE_MESSAGE.value,
        { emailTransactionLimit },
      );

export const TEMPLATE_VARIABLES_SIDEBAR = {
  VARIABLES_SIDEBAR_TITLE: { key: 'VARIABLES_SIDEBAR_TITLE', value: 'Variables' },
  VARIABLES_SIDEBAR_DESCRIPTION: { key: 'VARIABLES_SIDEBAR_DESCRIPTION', value: 'List of variables used in this template' },
  PREVIEW_DOWNLOAD_DESCRIPTION: { key: 'PREVIEW_DOWNLOAD_DESCRIPTION', value: 'Provide custom values for the variables below to Preview or Download Document' },
  PREVIEW_SEND_EMAIL_DESCRIPTION: { key: 'PREVIEW_SEND_EMAIL_DESCRIPTION', value: 'Provide custom values for the variables below to Preview or to Send email' },
  NO_VARIABLES_IN_TEMPLATE_DESCRIPTION: {
    key: 'NO_VARIABLES_IN_TEMPLATE_DESCRIPTION',
    value: 'No variables defined. Select the text to assign a variable name',
  },
  TABLE_VARIABLE_TOOLTIP: { key: 'TABLE_VARIABLE_TOOLTIP', value: 'Table Variable' },
  DATE_VARIABLE_TOOLTIP: { key: 'DATE_VARIABLE_TOOLTIP', value: 'Date Variable' },
  MULTI_VALUE_VARIABLE_TOOLTIP: {
    key: 'MULTI_VALUE_VARIABLE_TOOLTIP',
    value: 'List Variable',
  },
  HTML_VARIABLE_TOOLTIP: { key: 'HTML_VARIABLE_TOOLTIP', value: 'Html Variable' },
  BOOLEAN_VARIABLE_TOOLTIP: { key: 'BOOLEAN_VARIABLE_TOOLTIP', value: 'Boolean Variable' },
  STRING_VARIABLE_TOOLTIP: { key: 'STRING_VARIABLE_TOOLTIP', value: 'String Variable' },
  REPEAT_VARIABLE_TOOLTIP: { key: 'REPEAT_VARIABLE_TOOLTIP', value: 'Repetitive Block Variable' },
  TABLE_VARIABLE_TOOLTIP: { key: 'TABLE_VARIABLE_TOOLTIP', value: 'Table Variable' },
  CHART_VARIABLE_TOOLTIP: { key: 'CHART_VARIABLE_TOOLTIP', value: 'Chart Variable' },
  FORM_VARIABLE_TOOLTIP: { key: 'FORM_VARIABLE_TOOLTIP', value: 'Form Variable' },
  DESIGN_RELEASED_SUCCESSFULLY_MESSAGE: { key: 'DESIGN_RELEASED_SUCCESSFULLY_MESSAGE', value: 'Design successfully released' },
  ERROR_IN_DOCUMENT:{ key: 'ERROR_IN_DOCUMENT', value: 'Please correct the errors in the template design before previewing or downloading this document.'},
  PREMIUM_ACCOUNT_UPGRADE_MESSAGE: {
    key: 'PREMIUM_ACCOUNT_UPGRADE_MESSAGE',
    value: "You have reached the limit for sending emails under your current plan. You can either wait until your quota renews next month or upgrade to an enterprise plan. For assistance with upgrading, please contact our support team at <a href='mailto:{{emailId}}'>{{emailId}}</a>."
  },
  FREE_PLAN_UPGRADE_MESSAGE: {
    key: 'FREE_PLAN_UPGRADE_MESSAGE',
    value: 'In your free plan, you are limited to sending {{emailTransactionLimit}} emails. To send more emails, please upgrade your plan.'
  },
  STANDARD_PLAN_UPGRADE_MESSAGE: {
    key: 'STANDARD_PLAN_UPGRADE_MESSAGE',
    value: 'In your standard plan, you are limited to sending {{emailTransactionLimit}} emails. To send more emails, please upgrade your plan.'
  },
  EMAIL_REQUEST_TRIGGERED:{ key: 'EMAIL_REQUEST_TRIGGERED', value: 'Email requests triggered!!'},
  REQUIRED_ERROR_MESSAGE: {
    key: 'REQUIRED_ERROR_MESSAGE',
    value: 'This is a required field.'
  },
  MAX_CHAR_ERROR_MESSAGE: {
    key: 'MAX_CHAR_ERROR_MESSAGE',
    value: 'This field exceeded max characters allowed.'
  },
  DATE_FORMAT_ERROR_MESSAGE: {
    key: 'DATE_FORMAT_ERROR_MESSAGE',
    value: 'This field requires value in date format.'
  },
  EMPTY_ERROR_MESSAGE: {
    key: 'EMPTY_ERROR_MESSAGE',
    value: 'This field should not be empty.'
  },
  CHART_VALUE_ERROR_MESSAGE: {
    key: 'CHART_VALUE_ERROR_MESSAGE',
    value: 'This field should be a number.'
  },
  BARCODE39_VALUE_ERROR_MESSAGE: {
    key: 'BARCODE39_VALUE_ERROR_MESSAGE',
    value: 'This field requires value in uppercase.'
  },
  BATCH_UPLOAD_SUCCESS_MESSAGE: {
    key: 'BATCH_UPLOAD_SUCCESS_MESSAGE',
    value: 'Your request has been successfully submitted. Please go to Dashboard -> Job Monitoring to check the status or download the files'
  },
  HTML_INVALID_ERROR_MESSAGE: {
    key: 'HTML_INVALID_ERROR_MESSAGE',
    value:'Please provide valid input and try again'
  },
  INVALID_IMAGE_ID: {
    key: 'INVALID_IMAGE_ID',
    value: 'Please provide a valid image ID'
  }
};
